import * as React from "react";
import { ConnectedFormSelect } from "../../FormSelect/FormSelect/FormSelect.js";
const PrefixSelect = (props) => {
  return /* @__PURE__ */ React.createElement(ConnectedFormSelect, { id: "salutation", name: "salutation", ...props });
};
export {
  PrefixSelect
};
//# sourceMappingURL=PrefixSelect.js.map
